import {CLEAR_LIST_CONTACT_RESPONSE, SET_LIST_CONTACT_RESPONSE, SET_CONTACTS, CLEAR_CONTACT} from '../mutation-types';

const initialState = {
  listContactResponse: null
};

const getters = {
  getListContactResponse: state => state.listContactResponse,
  getContacts: (state) => state.contacts,
};

const mutations = {
  [SET_LIST_CONTACT_RESPONSE](state, payload) {
    state.listContactResponse = payload;
  },
  [CLEAR_LIST_CONTACT_RESPONSE](state) {
    state.listContactResponse = null;
  },
  [SET_CONTACTS](state, contacts){
    state.contacts = contacts;
  },
  [CLEAR_CONTACT](state) {
    state.contacts = null;
  },
};

const actions = {
  setListContactResponse({ commit }, response) {
    commit(SET_LIST_CONTACT_RESPONSE, response);
  },
  clearListContactResponse({ commit }) {
    commit('CLEAR_LIST_CONTACT_RESPONSE');
  },
  clearContactsResponse({ commit }) {
    commit('CLEAR_CONTACT');
  },
};

export default {
  state: initialState,
  getters,
  mutations,
  actions
};
